import { CommonModule } from "@angular/common";
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from "@angular/core";
import {
  ButtonBackgroundColor,
  ButtonType,
  ButtonTypeView,
  SpinnerSize,
} from "@app/shared/enums/common";

import { DomainColor } from "@app/shared/models";

import { SpinnerComponent } from "@app/shared/loaders/spinner/spinner.component";
import { NotificationCounterComponent } from "../notification-counter/notification-counter.component";
import { SvgIconComponent } from "../svg-icon/svg-icon.component";
import { SvgIcon } from "../svg-icon/svg-icons.model";

@Component({
  selector: "app-button",
  templateUrl: "./button.component.html",
  styleUrls: ["./button.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    SpinnerComponent,
    NotificationCounterComponent,
    SvgIconComponent,
  ],
})
export class ButtonComponent {
  @Input() type: ButtonType = ButtonType.Button;
  @Input() typeView: ButtonTypeView = ButtonTypeView.Default;
  @Input() backgroundColor: ButtonBackgroundColor | DomainColor =
    ButtonBackgroundColor.BackgroundDefault;
  @Input() text = "";
  @Input() nowrap = false;
  @Input() notification = false;
  @Input() notificationCounter = 0;
  @Input() minWidthDefaultActive = false;
  @Input() svgIcon: SvgIcon | string = "";
  @Input() svgIconActive = "";
  @Input() svgFill = "";
  @Input() svgWidth: string | null = null;
  @Input() svgHeight: string | null = null;
  @Input() svgClassActive = "";
  @Input() disabled = false;
  @Input() isLoading = false;
  @Input() spinnerSize: SpinnerSize = SpinnerSize.Middle;
  @Output() buttonClick = new EventEmitter();

  onButtonClick(event: any): void {
    this.buttonClick.emit(event);
  }

  getTypeViewClass(): string {
    if (
      this.typeView === ButtonTypeView.Simple ||
      this.typeView === ButtonTypeView.SimpleTextIcon ||
      this.typeView === ButtonTypeView.Close
    ) {
      return ButtonBackgroundColor.BackgroundNone;
    } else {
      return this.backgroundColor || ButtonBackgroundColor.BackgroundDefault;
    }
  }
}
